/**
 * Monitor OTA (Over-The-Air) error codes and messages
 * TODO: This data should eventually be moved to the database/API
 */

export interface OtaError {
    code: number
    message: string
}

export const otaErrorMessages: Record<number, string> = {
    0: 'No error',
    1: 'Impossible to find a memory bank to save downloaded file',
    2: 'Error found in the AWS job document',
    3: 'EN not detecting CO',
    4: 'TCP connection error (with AWS)',
    5: 'RF connection error (EN/CO communication link)',
    6: 'File to download is bigger than memory allocation',
    7: 'CRC error on downloaded file (EN)',
    8: 'CRC error on downloaded file (CO)',
    9: 'Downloaded file rejected by version validation (Firmware vs AWS Job Document)',
    10: 'Error creating or setting downloaded firmware FAT',
    11: 'EN firmware update self-test failed',
    12: 'CO stream file info error',
    13: 'CO stream binary error',
    14: 'CO download CRC error',
    15: 'CO firmware version error',
    16: 'CO download FAT error',
    17: 'CO self-test failed',
    18: 'Wireless update failed',
    19: 'Wireless update timeout'
}

/**
 * Get OTA error message by error code
 * @param errorCode - The OTA error code
 * @returns The error message or 'Unknown error' if not found
 */
export const getOtaErrorMessage = (errorCode: number | string | undefined | null): string => {
    if (errorCode === undefined || errorCode === null) return 'Unknown error'
    const code = typeof errorCode === 'string' ? Number(errorCode) : errorCode
    return otaErrorMessages[code] || `Unknown error (code: ${code})`
}

/**
 * Get all OTA error entries as an array
 * @returns Array of OTA error objects
 */
export const getAllOtaErrors = (): OtaError[] => {
    return Object.entries(otaErrorMessages).map(([code, message]) => ({
        code: Number(code),
        message
    }))
}

/**
 * Check if an error code indicates success (no error)
 * @param errorCode - The OTA error code
 * @returns True if the error code indicates no error
 */
export const isOtaSuccess = (errorCode: number | string | undefined | null): boolean => {
    if (errorCode === undefined || errorCode === null) return false
    const code = typeof errorCode === 'string' ? Number(errorCode) : errorCode
    return code === 0
}
